// @flow

import Colors from './default';
import SmallColors from './small';

export {
  SmallColors,
};

export default Colors;
